import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "help-table__content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "help-table__heading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "help-table__cell" }, "マニュアル名"),
  /*#__PURE__*/_createElementVNode("div", { class: "help-table__cell" }, "ファイル名"),
  /*#__PURE__*/_createElementVNode("div", { class: "help-table__cell" }, "ファイルサイズ")
], -1)

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";
import { HelpTableRow } from "..";

interface Props {
  modifires?: typeModifires;
  files: {
    name: string;
    file: { name: string; href: string; target: string };
    size: string;
  }[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'help-table',
  props: {
    modifires: { type: [String, Array, Boolean] },
    files: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('help-table', _ctx.modifires))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.files, (ele) => {
        return (_openBlock(), _createBlock(_unref(HelpTableRow), {
          key: ele.name,
          name: ele.name,
          file: ele.file,
          size: ele.size
        }, null, 8, ["name", "file", "size"]))
      }), 128))
    ])
  ], 2))
}
}

})